import React from 'react'
import Home from './pages/home/Home';

const App = () => {
  return (
    <div>
      <Home />
    </div>
  )
}

export default App
